import axios from 'axios';
import {apiUrl} from './apiAmbiente';
import {CHAVE_SESSAO} from './sessaoUsuario';
export async function consultarCredito(acao,dados={}){
 const token=sessionStorage.getItem(CHAVE_SESSAO)||'';if(!token)throw new Error('Renove sua sessão para consultar o crédito.');
 const fd=new FormData();fd.set('token',token);fd.set('acao',acao);Object.entries(dados).forEach(([k,v])=>fd.set(k,String(v)));
 try{const {data}=await axios.post(apiUrl('CreditoCliente.php'),fd);if(!data?.ok)throw new Error(data?.erro||'Crédito não confirmado.');return data;}
 catch(e){throw new Error(e.response?.data?.erro||e.message||'Não foi possível consultar o crédito.');}
}
